import { useMemo } from 'react';
import { HStack, Text } from '@bpba/ui-components';
import styled from 'styled-components';
import { maxWidth, MaxWidthProps } from 'styled-system';
import { InfoIcon } from '../components/shared/InfoIcon';

const INFO_ICON_SIZE = 20;

type Props<T> = {
  data?: T[];
  checkCondition?: (v: T) => boolean;
  message: string;
};

/**
 * Componente genérico que muestra un mensaje cuando
 * hay algún elemento en el arreglo que cumple la condición que
 * se solicita.
 * @param data - listado de elementos a controlar.
 * @param condition - función que devuelve verdadero si
 * el elemento cumple con determinada condición.
 * @param message - mensaje a mostrar.
 */
export const WarningMessage = <T,>({ data, checkCondition, message }: Props<T>) => {
  const condition = useMemo(() => data?.some((value) => checkCondition?.(value)), [data, checkCondition]);

  if (!condition) return <></>;

  return (
    <HStack color={'tertiary.0'} alignItems="center" tabIndex={0} lineHeight={'22px'} fontSize={'12px'}>
      <InfoIcon size={INFO_ICON_SIZE} />
      <StyledText textAlign={'justify'} marginX={'8px !important'} dangerouslySetInnerHTML={{ __html: message }} />
    </HStack>
  );
};

const StyledText = styled(Text)<MaxWidthProps>(maxWidth);
